import { ReactNode } from 'react';
import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from '@chakra-ui/react';
import clsx from 'clsx';
import {
  FormErrorMessagePropsWithTestId,
  FormLabelPropsWithTestId,
  HelpTextPropsWithTestId,
} from 'types/general.types';

interface AutocompleteFormControlProps {
  children: ReactNode;
  formControlProps: FormControlProps;
  labelProps?: FormLabelPropsWithTestId;
  name?: string;
  hasPlaceholder?: boolean;
  label?: string;
  helperText?: string;
  errorMessage?: ReactNode;
  helperTextProps?: HelpTextPropsWithTestId;
  errorMessageProps?: FormErrorMessagePropsWithTestId;
}

export const AutocompleteFormControl = ({
  children,
  formControlProps: { id, isRequired, isDisabled, isInvalid, isReadOnly },
  labelProps,
  name,
  hasPlaceholder,
  label,
  helperText,
  errorMessage,
  helperTextProps,
  errorMessageProps,
}: AutocompleteFormControlProps) => (
  <FormControl
    variant="floating"
    {...{ id, isRequired, isDisabled, isInvalid, isReadOnly }}
  >
    {children}
    <FormLabel
      htmlFor={name || id}
      {...labelProps}
      className={clsx(labelProps?.className, {
        hasPlaceholder,
        isDisabled: Boolean(isDisabled),
      })}
    >
      {label}
    </FormLabel>
    {helperText && !errorMessage && (
      <FormHelperText {...helperTextProps}>{helperText}</FormHelperText>
    )}
    {errorMessage && (
      <FormErrorMessage {...errorMessageProps}>{errorMessage}</FormErrorMessage>
    )}
  </FormControl>
);
